import { render, staticRenderFns } from "./ProtectFile.vue?vue&type=template&id=788b8e5d&scoped=true&"
import script from "./ProtectFile.vue?vue&type=script&lang=js&"
export * from "./ProtectFile.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/protectFile.less?vue&type=style&index=0&id=788b8e5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b8e5d",
  null
  
)

export default component.exports